var map = {
	"./company.svg": 73434,
	"./deptment.svg": 92140,
	"./lesson1.svg": 72322,
	"./lesson2.svg": 43217,
	"./lesson3.svg": 80416,
	"./lesson4.svg": 38975,
	"./lesson5.svg": 17870,
	"./like-gray.svg": 94112,
	"./like.svg": 27940,
	"./like3.svg": 26671,
	"./menu1.svg": 16825,
	"./message-gray.svg": 2714,
	"./message.svg": 83026,
	"./message3.svg": 66029,
	"./person2.svg": 86808,
	"./person3.svg": 12169,
	"./person4.svg": 42758,
	"./person5.svg": 31735,
	"./person6.svg": 77284,
	"./person7.svg": 74533,
	"./person8.svg": 53186,
	"./process1.svg": 51069,
	"./process2.svg": 13246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;